var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":""}},[_c('br'),_c('br'),_c('h6',{staticClass:"unselectable"},[_vm._v("© RESTful College, 2021")])])}
var staticRenderFns = []

export { render, staticRenderFns }